<template>
  <div
    class="project"
    :data-page="$route.params.project"
  >
    <component
      v-for="(obj, key, i) in structure"
      :key="i"
      :is="$store.state.settings.components[obj.component].component"
      :data="obj.data"
    />
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue';
import DoubleImage from '@/components/DoubleImage.vue';
import PictureText from '@/components/PictureText.vue';
import QuickWords from '@/components/QuickWords.vue';
import DoubleColumn from '@/components/DoubleColumn.vue';
import Slider from '@/components/Slider.vue';
import Video from '@/components/VideoComponent.vue';
import ProjectFooter from '@/components/ProjectFooter.vue';

export default {
  name: 'project',

  components: {
    Hero,
    DoubleImage,
    QuickWords,
    PictureText,
    DoubleColumn,
    Slider,
    ProjectFooter,
    Video,
  },

  computed: {
    structure() {
      const childrens = this.$store.state.firebase.portfolio.childrens; // eslint-disable-line
      return childrens[this.$route.params.project].structure[this.$store.state.lang];
    },
  },
};
</script>

<style lang="scss" scoped>
.project {
  position: relative;
  width: 100%;

  box-sizing: border-box;
}
</style>
